export const CreditCardRefundSvg = ({
  fillColor = "none",
}: {
  fillColor?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill={fillColor}
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="icon icon-tabler icons-tabler-outline icon-tabler-credit-card-refund"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M12 19h-6a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v4.5" />
    <path d="M3 10h18" />
    <path d="M7 15h.01" />
    <path d="M11 15h2" />
    <path d="M16 19h6" />
    <path d="M19 16l-3 3l3 3" />
  </svg>
);
